import Page from 'src/components/Page';
import { Box, Container, makeStyles, Divider } from '@material-ui/core';
import { Redeem as RedeemIcon } from '@material-ui/icons';
import Header from 'src/components/GeneralHeader';
import TabView from './TabView';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  }
}));
const FlashMe = ({ children }) => {
  const classes = useStyles();
  const text = 'Transfer credits to your loved ones.';

  return (
    <Page title="Vezeti | Transfer Credit" className={classes.root}>
      <Container maxWidth={false}>
        <Header icon={RedeemIcon} text={text} />
        <Box>
          <TabView />
          <Divider />
          <Box mt={2}>{children}</Box>
        </Box>
      </Container>
    </Page>
  );
};

export default FlashMe;
